import { render, staticRenderFns } from "./DecoratorInput.vue?vue&type=template&id=7646b7b1&scoped=true&"
import script from "./DecoratorInput.vue?vue&type=script&lang=js&"
export * from "./DecoratorInput.vue?vue&type=script&lang=js&"
import style0 from "./DecoratorInput.vue?vue&type=style&index=0&id=7646b7b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7646b7b1",
  null
  
)

export default component.exports